<div class="my-content">
  <app-loader [isLoading]="isLoading"></app-loader>
  <div class="top">
    <div class="title" translate="registration.register-login"></div>
    <div class="view-it" translate="registration.view-it"></div>
  </div>

  <div [class.hidden]="!error || accounts.length === 0" class="text-center existing-account-box">
    <div translate="registration.existing-account" class="existing-account"></div>
    <div translate="registration.account-created-with" [translateParams]="{value: existingAccounts}"></div>
    <div translate="registration.login-with"></div>
    <div class="social-login is-flex">
      <div class="flex-one is-flex centered" *ngIf="hasFacebook">
        <app-social provider="facebook"></app-social>
      </div>
      <div class="flex-one is-flex centered" *ngIf="hasGoogle">
        <app-social provider="google"></app-social>
      </div>
      <div class="flex-one is-flex centered" *ngIf="hasEmail">
        <button (click)="switchToEmail()" class="btn email-button">{{ getAccountName(SocialType.NotSocial) }}</button>
      </div>
    </div>
    <div class="divider">
      <div class="text" translate="registration.or"></div>
    </div>
    <div (click)="continueLogin()">
      <a translate="registration.continue-to-make-new-account-with" [translateParams]="{value: buttonMessage}"></a>
    </div>
  </div>

  <div [class.hidden]="error && accounts.length > 0">
  <div class="social-login is-flex">
    <div class="flex-one is-flex centered">
      <app-social provider="facebook"></app-social>
    </div>
    <div class="flex-one is-flex centered">
      <app-social provider="google"></app-social>
    </div>
  </div>

  <div class="divider">
    <div class="text" translate="registration.or"></div>
  </div>

  <form class="form" (ngSubmit)="onSubmit()" [formGroup]="loginForm">
    <ng-container *ngIf="error">
      <div class="error" [translate]="error" [translateParams]="{value: accounts}"></div>
      <div *ngIf="accounts.length > 0">
        <button class="btn" (click)="continueLogin()">{{ buttonMessage }}</button>
      </div>
    </ng-container>

    <app-input label="{{'registration.email' | translate}}" inputType="email" [parentFormGroup]="loginForm" [formControl]="userEmail"
      inputId="signIn-input-email" [errorText]="'errors.invalid-email-format' | translate" [isRequired]="true"></app-input>
    <fieldset formGroupName="password">
      <app-input pattern="^.{6,}$"
        label="{{'registration.password' | translate}}" [inputType]="showPasswordText ? 'text': 'password'"
        [parentFormGroup]="passwordFormGroup" [formControl]="password"
        [class.has-errors]="this.loginMode
        ? (this.passwordFormGroup.invalid && (this.password.dirty || this.password.touched))
        : this.passwordFormGroup.invalid && (this.confirmPassword.dirty || this.confirmPassword.touched)"
        inputId="signIn-input-password" [isRequired]="true">
        <span [class.hidden]="!password.value" class="show-hide form-control-feedback-text" (click)="showPasswordText = !showPasswordText"
          [translate]="showPasswordText ? 'form.hide' : 'form.show'">
        </span>
      </app-input>
    </fieldset>
    <ng-container *ngIf="loginMode">
      <div class="form-group forgot-password">
        <a id="signIn-link-forgot-password" translate="registration.forgot-password" (click)="showForgotPassword.emit({show: true, email: email})"></a>
      </div>

      <div class="form-group is-flex remember-me">
        <div class="flex-one">
          <div style="display: inline-block">
            <app-checkbox inputId="signIn-checkbox-rememberMe" [inverted]="true" [text]="'registration.remember-me' | translate" class="fixed-height" [formControl]="loginForm.get('rememberMe')" [parentFormGroup]="loginForm"></app-checkbox>
          </div>
        </div>
        <div class="flex-one has-padding-left">
          <button type="submit" id="signIn-button-login" class="btn btn-primary login" [disabled]="!userEmail.valid || !password.valid" translate="registration.log-in"
            angulartics2On="click" [angularticsProperties]="'_log_into_account' | listingTypeAnalyticsTag | async"
          ></button>
        </div>
      </div>

      <button id="signIn-button-register" type="button" class="btn btn-primary" (click)="setLoginMode(false)" translate="registration.register"></button>
    </ng-container>

    <ng-container *ngIf="!loginMode">
      <fieldset formGroupName="password">
        <app-input pattern="^.{6,}$"
        label="{{'registration.confirm-password' | translate}}" [inputType]="showConfirmPasswordText ? 'text': 'password'"
        [parentFormGroup]="passwordFormGroup" [formControl]="confirmPassword"
        [class.has-errors]="this.passwordFormGroup.invalid && (this.confirmPassword.dirty || this.confirmPassword.touched)"
        inputId="input-account-confirm-password" [isRequired]="true">
          <span [class.hidden]="!confirmPassword.value" class="show-hide form-control-feedback-text" (click)="showConfirmPasswordText = !showConfirmPasswordText"
            [translate]="showConfirmPasswordText ? 'form.hide' : 'form.show'">
          </span>
          <p class="error-clue" *ngIf="this.passwordFormGroup.invalid && (this.confirmPassword.dirty || this.confirmPassword.touched)">Passwords don't match</p>
        </app-input>
      </fieldset>
      <div class="form-group terms is-flex">
        <div>
          <app-checkbox [inverted]="true" class="fixed-height" [formControl]="loginForm.get('termsAndCond')" [parentFormGroup]="loginForm">
          </app-checkbox>
        </div>
        <div class="is-flex has-flex-align-center">
          <span translate="registration.i-agree"></span>&nbsp;
          <a target="_blank" rel="noopener" href="/editorial/copyright-terms-of-use/" translate="registration.terms-and-conditions"></a>
        </div>
      </div>
      <app-recaptcha [onSubmit]="getOnSubmit()" (recaptchaIdCreated)="recaptchaId=$event"></app-recaptcha>
      <div class="buttons">
        <button type="button" class="btn btn-primary" [disabled]="!loginForm.valid" translate="registration.register" (click)="sendGrecaptcha()"
          angulartics2On="click" [angularticsProperties]="'_register_for_account' | listingTypeAnalyticsTag | async"
        ></button>
        <div class="cancel">
          <a (click)="setLoginMode(true)" translate="registration.cancel"></a>
        </div>
      </div>
    </ng-container>
  </form>
  </div>
</div>
